import {refreshToken, clearStore} from '../store'

let tokenTimer
let tokenTimestamp

export function stopTokenRefresh() {
    if(tokenTimer) clearTimeout(tokenTimer)
    tokenTimer = null
}

export function refreshTokenTimer(){
    tokenTimestamp = +new Date()
    if ( !tokenTimer ) {
        tokenTimer = setInterval(() => {
            if ( (+new Date() - tokenTimestamp) > 170000) {
                refreshToken()
                tokenTimestamp = +new Date()
            }
        },500 )
    }
}

let activityTimer
let activityTimestamp

export function refreshActivityTimer(){
    activityTimestamp = +new Date()
    if ( !activityTimer ) {
        activityTimer = setInterval(() => {
            if ( (+new Date() - activityTimestamp) > 180000) {
                clearInterval(activityTimer)
                activityTimer = null
                clearStore()
            }
        },500 )
    }
}


// WEBPACK FOOTER //
// ./src/components/timeout.js